export default __webpack_public_path__ + "static/media/shotgun.33d0a2ad.png";